module.exports = __webpack_public_path__ + "static/news (2)-faeba130ad0cbb47c3eaf4a7e2c66691.jpg";